import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-the-h01-profile-panel__left" }
const _hoisted_2 = {
  key: 0,
  class: "p-the-h01-profile-panel__icon"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "p-the-h01-profile-panel__right" }
const _hoisted_5 = { class: "p-the-h01-profile-panel__profile" }
const _hoisted_6 = {
  class: "p-the-h01-profile-panel__profile__name",
  "data-translate-skip": ""
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-the-h01-profile-panel__navi" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "p-the-h01-profile-panel__navi__text" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "p-the-h01-point-area" }
const _hoisted_22 = { class: "p-the-h01-point-left" }
const _hoisted_23 = { class: "p-the-h01-replaceable-point-panel" }
const _hoisted_24 = { class: "p-the-h01-replaceable-point-panel__top" }
const _hoisted_25 = { class: "p-the-h01-replaceable-point-panel__total" }
const _hoisted_26 = { class: "p-the-h01-replaceable-point-panel__total__header" }
const _hoisted_27 = {
  class: "p-the-h01-replaceable-point-panel__total__point",
  "data-translate-skip": ""
}
const _hoisted_28 = { class: "p-the-h01-replaceable-point-panel__total__point__text" }
const _hoisted_29 = { class: "p-the-h01-replaceable-point-panel__total__point__unit" }
const _hoisted_30 = {
  key: 0,
  class: "p-the-h01-replaceable-point-panel__buttons"
}
const _hoisted_31 = { class: "p-the-h01-replaceable-point-panel__buttons__label" }
const _hoisted_32 = { class: "p-the-h01-replaceable-point-panel__buttons__label" }
const _hoisted_33 = { class: "p-the-h01-replaceable-point-panel__bottom" }
const _hoisted_34 = {
  key: 0,
  class: "p-the-h01-replaceable-point-panel__list__item"
}
const _hoisted_35 = { class: "p-the-h01-replaceable-point-panel__list__point" }
const _hoisted_36 = {
  key: 0,
  class: "p-the-h01-replaceable-point-panel__list__point__text"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  class: "p-the-h01-replaceable-point-panel__list__point__unit",
  "data-translate-skip": ""
}
const _hoisted_39 = {
  key: 1,
  class: "p-the-h01-replaceable-point-panel__list__item"
}
const _hoisted_40 = { class: "p-the-h01-replaceable-point-panel__list__heading" }
const _hoisted_41 = { class: "p-the-h01-replaceable-point-panel__list__point" }
const _hoisted_42 = {
  key: 0,
  class: "p-the-h01-replaceable-point-panel__list__point__text"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  class: "p-the-h01-replaceable-point-panel__list__point__unit",
  "data-translate-skip": ""
}
const _hoisted_45 = {
  key: 2,
  class: "p-the-h01-replaceable-point-panel__list__item"
}
const _hoisted_46 = { class: "p-the-h01-replaceable-point-panel__list__point" }
const _hoisted_47 = {
  key: 0,
  class: "p-the-h01-replaceable-point-panel__list__point__text"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  class: "p-the-h01-replaceable-point-panel__list__point__unit",
  "data-translate-skip": ""
}
const _hoisted_50 = {
  key: 3,
  class: "p-the-h01-replaceable-point-panel__list__item"
}
const _hoisted_51 = { class: "p-the-h01-replaceable-point-panel__list__heading" }
const _hoisted_52 = { class: "p-the-h01-replaceable-point-panel__list__point" }
const _hoisted_53 = {
  key: 0,
  class: "p-the-h01-replaceable-point-panel__list__point__text"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  class: "p-the-h01-replaceable-point-panel__list__point__unit",
  "data-translate-skip": ""
}
const _hoisted_56 = {
  key: 0,
  class: "p-the-h01-thanks-only-point-panel"
}
const _hoisted_57 = { class: "p-the-h01-thanks-only-point-panel__heading" }
const _hoisted_58 = { class: "p-the-h01-thanks-only-point-panel__tooltip" }
const _hoisted_59 = {
  class: "p-the-h01-thanks-only-point-panel__point",
  "data-translate-skip": ""
}
const _hoisted_60 = { class: "p-the-h01-thanks-only-point-panel__point__text" }
const _hoisted_61 = { class: "p-the-h01-thanks-only-point-panel__point__unit" }
const _hoisted_62 = { class: "p-the-h01-expiration-panel" }
const _hoisted_63 = ["href"]
const _hoisted_64 = ["href"]
const _hoisted_65 = { class: "p-the-h01-point-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_IconUserRank = _resolveComponent("IconUserRank")!
  const _component_HelpTooltip = _resolveComponent("HelpTooltip")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheH01PointAchievementPanel = _resolveComponent("TheH01PointAchievementPanel")!
  const _component_TheH01GrantCriteriaPanel = _resolveComponent("TheH01GrantCriteriaPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "p-the-h01-profile-panel",
      style: _normalizeStyle({backgroundColor: _ctx.lightColorCode})
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.userInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_IconUserImage, {
                size: 64,
                "is-loading": _ctx.isLoading
              }, {
                default: _withCtx(() => [
                  (_ctx.userInfo && _ctx.userInfo.avatar && _ctx.userInfo.avatar !== '')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "avatar",
                        src: _ctx.userInfo.avatar,
                        alt: _ctx.fullName
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["is-loading"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.fullName), 1),
          (!_ctx.isSp && _ctx.userInfo && _ctx.userInfo.rankDisplayEnabled === true)
            ? (_openBlock(), _createBlock(_component_IconUserRank, {
                key: 0,
                size: 120
              }, {
                default: _withCtx(() => [
                  (_ctx.rankImage)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.rankImage
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("nav", null, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.urls.mypage
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "マイページ", -1)
              ]), 8, _hoisted_9)
            ]),
            (_ctx.thanksPointEnabled && !_ctx.isGroupBudget)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("a", {
                    href: _ctx.urls.thanksPoint
                  }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.thanksName) + "メッセージ", 1)
                  ], 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.urls.whatsNew
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "お知らせ", -1)
              ]), 8, _hoisted_13)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.urls.orders
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "申込履歴", -1)
              ]), 8, _hoisted_14)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.urls.visit
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "閲覧履歴", -1)
              ]), 8, _hoisted_15)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.urls.favorites
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "お気に入り", -1)
              ]), 8, _hoisted_16)
            ]),
            (!_ctx.showMailSettings && !_ctx.isGroupBudget)
              ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                  _createElementVNode("a", {
                    href: _ctx.urls.mailSettings
                  }, _cache[5] || (_cache[5] = [
                    _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "メール受信設定", -1)
                  ]), 8, _hoisted_18)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.urls.faq
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "FAQ", -1)
              ]), 8, _hoisted_19)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.urls.qa
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "p-the-h01-profile-panel__navi__text" }, "お問い合わせ", -1)
              ]), 8, _hoisted_20)
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "p-the-h01-replaceable-point-panel__total__heading" }, "商品交換可能ポイント", -1)),
                (_ctx.thanksPointEnabled)
                  ? (_openBlock(), _createBlock(_component_HelpTooltip, {
                      key: 0,
                      text: _ctx.replaceablePointText
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.addComma(_ctx.replaceablePoint)), 1),
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.unit.point), 1)
              ])
            ]),
            (_ctx.localShowButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_ButtonMain, {
                    tag: "a",
                    class: "-life",
                    href: _ctx.urls.life,
                    style: {"background":"#089398"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.lifeText), 1),
                      _createVNode(_component_IconBase, {
                        width: 24,
                        height: 24,
                        "view-box": "0 0 24 24"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconArrowRight)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href"]),
                  _createVNode(_component_ButtonMain, {
                    tag: "a",
                    class: "-goods",
                    href: _ctx.urls.goods,
                    style: {"background":"#F36D0D"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.goodsText), 1),
                      _createVNode(_component_IconBase, {
                        width: 24,
                        height: 24,
                        "view-box": "0 0 24 24"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconArrowRight)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_ctx.isGroupBudget == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "p-the-h01-replaceable-point-panel__list__heading" }, "付与ポイント", -1)),
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.point.grant_points >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.addComma(_ctx.point.grant_points)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, "---")),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.unit.point), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.thanksPointEnabled || _ctx.point.thanks_points > 0) && _ctx.isGroupBudget == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.thanksPointName), 1),
                  _createElementVNode("div", _hoisted_41, [
                    (_ctx.point.thanks_points >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.addComma(_ctx.point.thanks_points)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_43, "---")),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.unit.point), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.ShowKenko && _ctx.isGroupBudget == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "p-the-h01-replaceable-point-panel__list__heading" }, "健康ポイント（自動付与）", -1)),
                  _createElementVNode("div", _hoisted_46, [
                    (_ctx.point.kenko_points >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.addComma(_ctx.point.kenko_points)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_48, "---")),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.unit.point), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isGroupBudget)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.userInfo.groupBudgetName), 1),
                  _createElementVNode("div", _hoisted_52, [
                    (_ctx.point.group_budget_point >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.addComma(_ctx.point.group_budget_point)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_54, "---")),
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.unit.point), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.thanksPointEnabled && _ctx.thanksExclusiveEnabled && _ctx.isGroupBudget == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("span", _hoisted_57, [
                _createTextVNode(_toDisplayString(_ctx.thanksOnlyPointName), 1),
                _createElementVNode("span", _hoisted_58, [
                  _createVNode(_component_HelpTooltip, { text: _ctx.thanksOnlyPointText }, null, 8, ["text"])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.addComma(_ctx.point.thanks_exclusive_points)), 1),
                _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.unit.point), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("a", {
            href: _ctx.urls.expiring,
            class: "p-the-h01-expiration-panel__link"
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("span", { class: "p-the-h01-expiration-panel__link__text" }, "ポイント有効期限一覧", -1)
          ]), 8, _hoisted_63),
          _createElementVNode("a", {
            href: _ctx.urls.expired,
            class: "p-the-h01-expiration-panel__link"
          }, _cache[12] || (_cache[12] = [
            _createElementVNode("span", { class: "p-the-h01-expiration-panel__link__text" }, "有効期限切れのポイント一覧", -1)
          ]), 8, _hoisted_64)
        ]),
        _createVNode(_component_TheH01PointAchievementPanel)
      ]),
      _createElementVNode("div", _hoisted_65, [
        _createVNode(_component_TheH01GrantCriteriaPanel)
      ])
    ])
  ], 64))
}